"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormControlLogic extends _react.default.Component {
  componentDidUpdate(prevProps) {
    // If default field value has changed, change the current value.
    if ((this.props.initialValue || this.props.initialValue === '') && this.props.initialValue !== prevProps.initialValue || prevProps.initialValue && !this.props.initialValue) {
      const _this$props = this.props,
            name = _this$props.name,
            initialValue = _this$props.initialValue,
            required = _this$props.required,
            setValue = _this$props.setValue;
      setValue(name, initialValue, required);
    }
  }

  componentDidMount() {
    // Appply default field value.
    if (this.props.initialValue) {
      const _this$props2 = this.props,
            name = _this$props2.name,
            initialValue = _this$props2.initialValue,
            required = _this$props2.required,
            setValue = _this$props2.setValue;
      setValue(name, initialValue, required);
    }
  }

  render() {
    return this.props.children;
  }

}

FormControlLogic.propTypes = {
  name: _propTypes.default.string.isRequired,
  initialValue: _propTypes.default.any,
  required: _propTypes.default.bool,
  setValue: _propTypes.default.func.isRequired,
  children: _propTypes.default.node.isRequired
};
var _default = FormControlLogic;
exports.default = _default;